/*
overwriteModal.tsx
Copyright © 2026 Xerox Corporation. All Rights Reserved.

Copyright protection claimed includes all forms and matters of copyrightable material
and information now allowed by statutory or judicial law or hereinafter granted,
including without limitation, material generated from the software programs which
are displayed on the screen such as icons, screen display looks, etc.
*/

import { useTranslation } from "react-i18next"

export interface OverwriteModalProps {
    isOpen: boolean
    disableOverwrite?: boolean
    onClose: () => void
    onOverwrite: () => void
    onSaveAsNew: () => void
    presetName: string
}

export default function OverwriteModal (props: OverwriteModalProps) {
  const { t } = useTranslation()
  const { isOpen, onClose, onOverwrite, onSaveAsNew, presetName } = props   
    return (
    <div
      className={`xrx-modal fade ${isOpen ? 'show' : ''}`}
      id='overwrite-modal'
        tabIndex={-1}
        role='dialog'
        aria-labelledby='overwrite-modal-label'
        aria-hidden={!isOpen}
        {...isOpen ? {style: {display: "block"}} : {}}
    >
      { isOpen &&
      <div className='modal-dialog modal-dialog-centered px-0 modal-sm' role='document'>
        <div className='modal-content'>
            <div className='modal-header xrx-header header-danger'>
                <div className='d-flex align-items-center'>
                    <div className='xrx-stacked-icon stacked-icon-size-32'>
                        <i className='xgl-danger_stack_bkgd xglsize-32'></i>
                        <i className='xgl-danger_stack_mdgd xglsize-32'></i>
                        <i className='xgl-danger_stack_frgd xglsize-32'></i>
                    </div>
                    <h5 className='modal-title ml-3 mt-1' id='overwrite-modal-label'>{t('OVERWRITE_PRESET', {preset: presetName})}</h5>
                </div>
                <button 
                    type='button' 
                    className='xrx-btn btn-glyph btn-borderless btn-inline btn-danger close' 
                    data-dismiss='xrx-modal'
                    onClick={onClose}
                >
                    <i aria-hidden='true' className='xgl-close xglsize-32'></i>
                    <span className='sr-only'>close</span>
                </button>
            </div>
            <div className='modal-body' tabIndex={-1}>
                <div className="d-flex flex-column w-100">
                    <button 
                        className="xrx-btn btn-block mb-2" 
                        onClick={onClose}
                    >
                        <div className="d-flex align-items-center justify-content-center">
                            <i className="xgl-close xglsize-32 mr-2"></i>
                            <span className="btn-label">{t('CANCEL')}</span>
                        </div>
                    </button>
                    <button 
                        className="xrx-btn btn-block mb-2" 
                        onClick={onSaveAsNew}
                    >
                        <div className="d-flex align-items-center justify-content-center">
                            <i className="xgl-download_square xglsize-32 mr-2"></i>
                            <span className="btn-label">{t('SAVE_AS_NEW_PRESET')}</span>
                        </div>
                    </button>
                    {!props.disableOverwrite && 
                    <button 
                        className="xrx-btn btn-danger btn-block" 
                        onClick={onOverwrite}
                    >
                        <div className="d-flex align-items-center justify-content-center">
                            <i className="xgl-checkmark xglsize-32 mr-2"></i>
                            <span className="btn-label">{t('OVERWRITE')}</span>
                        </div>
                    </button>
}
                </div>
            </div>
        </div>
        </div>
      }
    </div>
    )
}